import { Routes, Route, Navigate } from 'react-router-dom'
import { LoginPage } from './routes/auth/LoginPage'
import { AppShell } from './components/layout/AppShell'
import { HomePage } from './routes/HomePage'
import { useAuthStore } from './stores/auth.store'

export function App() {
  const token = useAuthStore((s) => s.token)

  return (
    <Routes>
      <Route path="/login" element={token ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={token ? <AppShell /> : <Navigate to="/login" replace />}>
        <Route index element={<HomePage />} />
      </Route>
      <Route path="*" element={<Navigate to={token ? '/' : '/login'} replace />} />
    </Routes>
  )
}
